export default __webpack_public_path__ + "static/media/logo.d99b6ce6.svg";